import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import NewPasswordModal from './new-password-modal.vue';

const MOUNT_ID = 'global-new-password-modal-vue';

let newPasswordModalApp: App<Element> | null = null;
let newPasswordModalInstance: { open: () => void } | null = null;
let currentMountEl: HTMLElement | null = null;

function resolveMountRoot(root?: ParentNode): HTMLElement | null {
  const fromDom = root
    ? root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID)
    : document.getElementById(MOUNT_ID);

  if (fromDom) return fromDom;

  const dynamicMountEl = document.createElement('div');
  dynamicMountEl.id = MOUNT_ID;
  document.body.appendChild(dynamicMountEl);
  return dynamicMountEl;
}

function mountNewPasswordModal(root?: ParentNode): void {
  const mountEl = resolveMountRoot(root);
  if (!mountEl) return;

  if (newPasswordModalApp && currentMountEl) {
    newPasswordModalApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(NewPasswordModal);
  app.use(AntDesignVue);
  const instance = app.mount(mountEl) as unknown as { open: () => void };

  newPasswordModalApp = app;
  newPasswordModalInstance = instance;
  currentMountEl = mountEl;
}

function shouldOpenNewPasswordModalFromUrl(): boolean {
  const value = new URLSearchParams(window.location.search).get('change_password');
  return value === 'yes';
}

export function initNewPasswordModalFromUrl(root?: ParentNode): void {
  mountNewPasswordModal(root);

  if (!shouldOpenNewPasswordModalFromUrl()) return;
  newPasswordModalInstance?.open();
}
